import React from 'react';
import { Trophy, Medal, Award, TrendingUp } from 'lucide-react';

const LeaderboardPanel = ({ leaderboard }) => {
  const getRankIcon = (rank) => {
    switch (rank) {
      case 1:
        return <Trophy className="w-6 h-6 text-yellow-500" />;
      case 2:
        return <Medal className="w-6 h-6 text-gray-400" />;
      case 3:
        return <Medal className="w-6 h-6 text-orange-600" />;
      default:
        return <Award className="w-5 h-5 text-gray-400" />;
    }
  };

  const getRankBadge = (rank) => {
    const badges = {
      1: 'bg-gradient-to-r from-yellow-400 to-yellow-600 text-white',
      2: 'bg-gradient-to-r from-gray-300 to-gray-400 text-gray-800',
      3: 'bg-gradient-to-r from-orange-400 to-orange-600 text-white'
    };
    return badges?.[rank] || 'bg-gray-200 text-gray-700';
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <Trophy className="w-6 h-6 text-yellow-500" />
        <h2 className="text-2xl font-bold text-gray-900">Pronunciation Leaderboard</h2>
      </div>
      {leaderboard?.length === 0 ? (
        <div className="text-center py-12">
          <TrendingUp className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-600">No ranking data available yet.</p>
          <p className="text-sm text-gray-500 mt-2">
            Start practicing to see where you rank!
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {leaderboard?.map((entry, index) => {
            const rank = index + 1;
            return (
              <div
                key={entry?.user_id}
                className={`flex items-center gap-4 p-4 rounded-lg border-2 transition-all ${
                  rank <= 3
                    ? 'bg-gradient-to-r from-yellow-50 to-orange-50 border-yellow-200' :'bg-gray-50 border-gray-200'
                }`}
              >
                {/* Rank */}
                <div className="flex-shrink-0">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${getRankBadge(rank)}`}>
                    {rank}
                  </div>
                </div>
                {/* Icon */}
                <div className="flex-shrink-0">
                  {getRankIcon(rank)}
                </div>
                {/* User Info */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 truncate">
                    {entry?.full_name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {entry?.count} {entry?.count === 1 ? 'practice' : 'practices'}
                  </p>
                </div>
                {/* Score */}
                <div className="flex-shrink-0 text-right">
                  <div className="text-2xl font-bold text-purple-600">
                    {entry?.average_score}%
                  </div>
                  <div className="text-xs text-gray-500">
                    avg accuracy
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {/* Footer Note */}
      {leaderboard?.length > 0 && (
        <div className="mt-6 p-4 bg-purple-50 rounded-lg border border-purple-200">
          <p className="text-sm text-purple-700 text-center">
            Rankings based on average pronunciation accuracy. Keep practicing to climb higher! 🎯
          </p>
        </div>
      )}
    </div>
  );
};

export default LeaderboardPanel;